import { createContext } from 'react';

/**
 * Array of all 6 public-facing locales.
 */
export const localeArray = ['pt-br', 'de-de', 'en-us', 'es-es', 'fr-fr', 'ja-jp'];

/**
 * Locale for each public-facing TLD. For example, `ja-JP` for the Japanese
 * TLD.
 */

/**
 * The context for the locale.
 * @default 'en-us'
 */
export const LocaleContext = /*#__PURE__*/createContext('en-us');
const {
  Provider
} = LocaleContext;
export { Provider as LocaleContextProvider };